import styled from 'styled-components';

import promoColors from '../../../../theme/promoColors';
import promoMedia from '../../../../theme/promoMedia';

export const AccordionList = styled.ul`
    list-style-type: none;
    margin: 0;
    padding: 0;

    & > li + li {
        margin-top: 16px;
    }

    ${promoMedia.tablet744} {
        & > li + li {
            margin-top: 24px;
        }
    }

    ${promoMedia.desktop1440} {
        & > li + li {
            margin-top: 32px;
        }
    }
`;
export const AccordionHeader = styled.a`
    background-color: ${promoColors.gray5};
    border-radius: 24px;
    cursor: pointer;
    display: flex;
    padding: 10px 16px;
    align-items: center;
    flex-grow: 1;
    justify-content: space-between;

    &:focus-visible {
        outline: 1px dashed ${promoColors.gray40};
    }

    ${promoMedia.desktop1440} {
        padding: 16px 24px;
    }
`;
export const AccordionHeaderContent = styled.div`
    display: flex;
    align-items: center;
    flex-grow: 1;
`;
export const AccordionFlag = styled.div`
    margin-right: 10px;

    ${promoMedia.tablet744} {
        margin-right: 12px;
    }
`;

export const AccordionIcon = styled.span`
    height: 24px;
    overflow: hidden;
    margin-left: 16px;
    min-width: 24px;
    transition-duration: 0.4s;
    transition-property: transform;
    width: 24px;
`;

export const AccordionContent = styled.div`
    margin-top: 8px;
    padding: 8px 16px;

    a {
        &:link,
        &:visited {
            text-decoration: underline;
        }
    }

    ${promoMedia.tablet744} {
        margin-top: 12px;
    }

    ${promoMedia.desktop1440} {
        margin-top: 16px;
        padding: 16px 24px;
    }
`;
